import React from "react";

const Trader_Admin = () => {
  return <div>Trader_Admin</div>;
};

export default Trader_Admin;
